import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b208804&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./converterNutritionalSolutions.scss?vue&type=style&index=0&id=4b208804&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b208804",
  null
  
)

export default component.exports